.joy-avatars-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;

    &.joy-avatars-list__compress {
        gap: 0;
    }
}